import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VBottomSheet,
    {
      attrs: { scrollable: "", value: _vm.value },
      on: {
        input: function ($event) {
          return _vm.$emit("input", $event)
        },
      },
    },
    [
      _vm.value
        ? _c(
            VCard,
            [
              _c(
                VCardTitle,
                { staticClass: "d-flex justify-space-between align-center" },
                [
                  _c("span", [
                    _vm._v(
                      "Inventory #" +
                        _vm._s(_vm.inventoryId) +
                        " - Availability"
                    ),
                  ]),
                  _c(
                    VBtn,
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("input", false)
                        },
                      },
                    },
                    [_c(VIcon, [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c(VDivider),
              _vm.loading
                ? _c(
                    VCardText,
                    { staticClass: "text-center py-8" },
                    [
                      _c(VProgressCircular, {
                        attrs: { indeterminate: "", color: "primary" },
                      }),
                    ],
                    1
                  )
                : _c(
                    VCardText,
                    [
                      _c(
                        VSheet,
                        {
                          staticClass: "pa-4 mb-4",
                          attrs: { rounded: "", outlined: "" },
                        },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(VCol, { attrs: { cols: "12" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-space-between text-body-2",
                                  },
                                  [
                                    _c("span", [_vm._v("Original Weight:")]),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatWeight(_vm.originalWeight)
                                        ) + " kg"
                                      ),
                                    ]),
                                  ]
                                ),
                              ]),
                              _c(VCol, { attrs: { cols: "12" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-space-between text-body-2",
                                  },
                                  [
                                    _c("span", [_vm._v("Used Weight:")]),
                                    _c("span", [
                                      _vm._v(
                                        "-" +
                                          _vm._s(
                                            _vm.formatWeight(_vm.usedWeight)
                                          ) +
                                          " kg"
                                      ),
                                    ]),
                                  ]
                                ),
                              ]),
                              _c(VCol, { attrs: { cols: "12" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-space-between text-body-2",
                                  },
                                  [
                                    _c("span", [_vm._v("Reserved Weight:")]),
                                    _c(
                                      "span",
                                      { staticClass: "orange--text" },
                                      [
                                        _vm._v(
                                          "-" +
                                            _vm._s(
                                              _vm.formatWeight(
                                                _vm.reservedWeight
                                              )
                                            ) +
                                            " kg"
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                VCol,
                                { attrs: { cols: "12" } },
                                [
                                  _c(VDivider, { staticClass: "my-1" }),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-space-between text-body-1 font-weight-bold",
                                    },
                                    [
                                      _c("span", [_vm._v("Freely Available:")]),
                                      _c(
                                        "span",
                                        {
                                          class:
                                            _vm.freeWeight > 0
                                              ? "green--text"
                                              : "red--text",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.formatWeight(_vm.freeWeight)
                                              ) +
                                              " kg "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(VProgressLinear, {
                            staticClass: "mt-4",
                            attrs: {
                              value: _vm.usedPercent,
                              "buffer-value":
                                _vm.usedPercent + _vm.reservedPercent,
                              color: "grey",
                              "buffer-color": "orange",
                              "background-color": "green lighten-3",
                              height: "20",
                              rounded: "",
                            },
                          }),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-space-between text-caption mt-1",
                            },
                            [
                              _c("span", { staticClass: "grey--text" }, [
                                _vm._v(
                                  "Used " +
                                    _vm._s(_vm.usedPercent.toFixed(1)) +
                                    "%"
                                ),
                              ]),
                              _c("span", { staticClass: "orange--text" }, [
                                _vm._v(
                                  "Reserved " +
                                    _vm._s(_vm.reservedPercent.toFixed(1)) +
                                    "%"
                                ),
                              ]),
                              _c("span", { staticClass: "green--text" }, [
                                _vm._v(
                                  "Free " +
                                    _vm._s(_vm.freePercent.toFixed(1)) +
                                    "%"
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(VDivider, { staticClass: "mb-4" }),
                      _c(
                        "div",
                        {
                          staticClass:
                            "text-subtitle-1 font-weight-medium mb-2",
                        },
                        [
                          _vm._v(
                            " Reservations (" +
                              _vm._s(_vm.reservations.length) +
                              ") "
                          ),
                        ]
                      ),
                      _vm.reservations.length > 0
                        ? _c(VSimpleTable, {
                            attrs: { dense: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function () {
                                    return [
                                      _c("thead", [
                                        _c("tr", [
                                          _c("th", [_vm._v("Worksheet ID")]),
                                          _c("th", [_vm._v("Entry ID")]),
                                          _c(
                                            "th",
                                            { staticClass: "text-right" },
                                            [_vm._v("Quantity (kg)")]
                                          ),
                                          _c("th", [_vm._v("Reserved On")]),
                                          _c("th", [_vm._v("Age")]),
                                          _c(
                                            "th",
                                            { staticClass: "text-right" },
                                            [_vm._v("Actions")]
                                          ),
                                        ]),
                                      ]),
                                      _c(
                                        "tbody",
                                        _vm._l(_vm.reservations, function (r) {
                                          return _c("tr", { key: r.id }, [
                                            _c("td", [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "primary--text",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.openWorksheet(
                                                        r.processWorksheetId
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        r.processWorksheetId
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  r.processWorksheetInputId ||
                                                    "-"
                                                )
                                              ),
                                            ]),
                                            _c(
                                              "td",
                                              { staticClass: "text-right" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("formatNumber")(
                                                      r.quantity
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("formatDateYear")(
                                                    r.createTime
                                                  )
                                                )
                                              ),
                                            ]),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(_vm.getAge(r.createTime))
                                              ),
                                            ]),
                                            _c(
                                              "td",
                                              { staticClass: "text-right" },
                                              [
                                                _c(
                                                  VBtn,
                                                  {
                                                    attrs: {
                                                      icon: "",
                                                      small: "",
                                                      color: "orange",
                                                      title:
                                                        "Release reservation",
                                                      loading:
                                                        _vm.releasingId ===
                                                        r.id,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.confirmRelease(
                                                          r
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      VIcon,
                                                      { attrs: { small: "" } },
                                                      [
                                                        _vm._v(
                                                          "mdi-lock-open-outline"
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ])
                                        }),
                                        0
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              4112611022
                            ),
                          })
                        : _c(
                            "div",
                            {
                              staticClass:
                                "text-center text-caption grey--text pa-4",
                            },
                            [
                              _vm._v(
                                " No active reservations for this inventory. "
                              ),
                            ]
                          ),
                    ],
                    1
                  ),
              _c(
                VDialog,
                {
                  attrs: { "max-width": "400", persistent: "" },
                  model: {
                    value: _vm.confirmDialog,
                    callback: function ($$v) {
                      _vm.confirmDialog = $$v
                    },
                    expression: "confirmDialog",
                  },
                },
                [
                  _c(
                    VCard,
                    [
                      _c(VCardTitle, { staticClass: "text-subtitle-1" }, [
                        _vm._v("Confirm Release"),
                      ]),
                      _vm.releaseTarget
                        ? _c(VCardText, [
                            _vm._v(" Release reservation of "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("formatNumber")(
                                    _vm.releaseTarget.quantity
                                  )
                                ) + " kg"
                              ),
                            ]),
                            _vm._v(
                              " from Worksheet #" +
                                _vm._s(_vm.releaseTarget.processWorksheetId) +
                                "? "
                            ),
                          ])
                        : _vm._e(),
                      _c(
                        VCardActions,
                        [
                          _c(VSpacer),
                          _c(
                            VBtn,
                            {
                              attrs: { text: "" },
                              on: {
                                click: function ($event) {
                                  _vm.confirmDialog = false
                                },
                              },
                            },
                            [_vm._v("Cancel")]
                          ),
                          _c(
                            VBtn,
                            {
                              attrs: { color: "orange", text: "" },
                              on: { click: _vm.doRelease },
                            },
                            [_vm._v("Release")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }